import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { TextField, Card, CardText, CardTitle } from "react-md";
import { dateTimeToStringWithDOW } from "components/Shared/Formatters";
import moment from "moment-timezone";

export default class TippedGridCell extends React.PureComponent {

    constructor(props) {
        super(props);
        this.tooltip = this.tooltip.bind(this);
        this.tooltipContent = this.tooltipContent.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.getId = this.getId.bind(this);
        this.getCurrentTimeFormatted = this.getCurrentTimeFormatted.bind(this);
    }

    getCurrentTimeFormatted(createdDateUTC) {
        return dateTimeToStringWithDOW(moment.utc(createdDateUTC).local().format());
      }

    getId() {
        return(`${this.props.cellViewModel.controlNumber}-${this.props.columnName}`);
    }

    handleClick(e) {
        e.stopPropagation(); 
    }

    tooltipContent() {
        return(
            <Card className="card-unnested">
                <CardTitle title={`${this.props.columnName} for Control # ${this.props.cellViewModel.controlNumber} by ${this.props.cellViewModel.value.author}, ${this.getCurrentTimeFormatted(this.props.cellViewModel.value.createdDateUTC)}`}/>
                <CardText>
                    <div className="tipped-cell-body">
                        <TextField
                            className={"tipped-cell-tip-text"}
                            value={this.props.cellViewModel.value.noteBody}
                            resize={{ min: 600, max: 600 }}
                            rows={1}
                            maxRows={20}
                            onChange={this.handleClick}
                            id={this.getId()+"text-field"}
                        />
                    </div>
            </CardText>
            </Card>
        );
    }

    tooltip() {
        if (this.props.cellViewModel.value.noteBody) {
            return (
            <div data-tip data-for={this.getId()}>
                <ReactTooltip
                id={this.getId()}
                effect="solid"
                place="right"
                delayHide={100}
                className="caseheader-contactinfo-tooltip grid-tooltip"
                scrollHide={true}
                border={true}
                >
                {
                    <div className="tipped-cell-tip">
                        {this.tooltipContent()}
                    </div>
                }
                </ReactTooltip>
            </div>
            );
        }
    }

  render() {
    const cellViewModel = this.props.cellViewModel;
    //Checks that Brian ma main man requested!
    //If the props aren't of the right type
    if(typeof cellViewModel !== "object" || cellViewModel === null) {
        return null;
    }
    //If the cellViewModel isn't actually a cellViewModel
    if(cellViewModel.value === null || cellViewModel.controlNumber === null) {
        return null;
    }
    //If the cellViewModel isn't the expected type of cellViewModel
    if(cellViewModel.value.noteBody === null || cellViewModel.value.author === null || cellViewModel.value.createdDateUTC === null) {
        return null;
    }

    return(
        <div 
        className="tipped-cell-container"
        onClick={this.handleClick}
        >
        <div data-tip data-for={this.getId()} className="tipped-cell-cellText">
            {this.props.cellViewModel.value.noteBody ? this.props.cellViewModel.value.noteBody.substring(0,100) : ""}
        </div>
        {this.tooltip()}
        </div>
    );
  }
}

TippedGridCell.propTypes = {
    cellViewModel: PropTypes.object.isRequired,
    columnName: PropTypes.string.isRequired,
};
